import { MatDateFormats } from '@angular/material/core';

/**
 * Display formats for the Material datepicker, expressed as Intl options so the
 * active locale decides the field ORDER rather than a hardcoded pattern.
 *
 * en-US renders 4/3/2026; es-US renders 3/4/2026 for the same day.
 * `DrdpDateAdapter.parse()` reads typed input back in that same order.
 *
 * Accessibility labels deliberately spell the month out. A screen-reader user
 * hearing "three slash four" has no way to tell which number is the day, so the
 * a11y label says "3 de abril de 2026" instead.
 */
export const DRDP_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: { day: 'numeric', month: 'numeric', year: 'numeric' },
  },
  display: {
    dateInput: { day: 'numeric', month: 'numeric', year: 'numeric' },
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};
